import React, { useRef } from 'react';
import { colorGrid } from 's2s-themes';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { getIntlText } from '../js/utilities';
import ImportContacts from './importContacts';
import Button from 's2s-button';
import AppService, { AlertService, Utilities } from 's2s-app-service';
import useAuth from "../hooks/auth";
import useAlerts from '../hooks/alerts';

const SettingsContainer = styled.div`
  background-color: ${colorGrid.gray0};
  display: flex;
  flex-direction: column;
  font-family: Open Sans;
  padding: 24px 24px 0 24px;
`;

const SettingsTitle = styled.div`
  color: #001221;
  font-size: 14px;
  font-weight: 600;
  line-height: 12px;
  padding: 10px 0 15px 0;
`;

const SettingsDescription = styled.div`
  color: #4c5863;
  font-size: 14px;
  line-height: 12px;
  padding-bottom: 10px;
`;

const SettingsItemContainer = styled.div`
  border-bottom: ${"1px solid " + colorGrid.gray3};
  margin-bottom: 15px;
  padding-bottom: 20px;
`;

const DownloadSampleButton = styled(Button)`
  background-color: #fff;
  border: 1px solid #a7b4e9;
  color: #243991;
  font-family: Open Sans;
  font-weight: 600;
  letter-spacing: 1.25px;
  line-height: 1;
  margin-top: 5px;
  text-transform: uppercase;
  
  :hover {
    background-color: #d3d9f4;
  }
`;

const DownloadBackupButton = DownloadSampleButton;

const ContactSettings = (props) => {
  const fileInput = useRef(null);
  const [auth] = useAuth();
  const [, { createErrorAlert }] = useAlerts();

  const importSourceArray = [
    {
      importSourceName: 'Google',
      importSourceSvg: 'GoogleIconSVG',
      importSourceLogoColor: '#f93f2d',
      importSourceLastSync: auth.auth.identity.properties.last_google_sync,
      cbImportSourceClick: () => { handleContactAction('importContacts', 'Google'); }
    },
    {
      importSourceName: 'Outlook',
      importSourceSvg: 'OutlookIconSVG',
      importSourceLogoColor: '#0072c6',
      importSourceLastSync: auth.auth.identity.properties.last_outlook_sync,
      cbImportSourceClick: () => { handleContactAction('importContacts', 'Outlook'); }
    },
    {
      importSourceName: 'CSV',
      importSourceSvg: 'CSVIconSVG',
      importSourceLogoColor: '#1098ad',
      importSourceLastSync: auth.auth.identity.properties.last_csv_sync,
      cbImportSourceClick: () => {
        fileInput.current.click();
      }
    }
  ];

  const handleContactAction = (action, params, csvFile) => {

    // console.log('jes here', action, params, params === "Google");
    switch (action) {
      case 'download':
        if (params === "sampleCSV") {
          const sampleCSV = '../../assets/files/importContactSampleEN.csv';
          const link = document.createElement("a");

          link.download = 'importContactSampleEN';
          link.href = sampleCSV;
          link.click();
        } else if (params === "backupCSV") {
          // console.log('please code me - backupCSV', params);
          downloadBackupCSV();
        } else {
          console.log('not handled download type ', params);
        }
        break;
      case 'importContacts':
        importContacts(params, csvFile);
        break;

      default:
        console.log('missing action in routes settingsSections ', action);
    }
  };

  const downloadBackupCSV = () => {
    AppService.getInstance().downloadContacts().then((data) => {
      const link = document.createElement("a");

      // set csv filename
      link.download = 'contactsBackup-' + Date.now() + '.csv';

      // set href for file data to be the attachment to the response
      link.href = 'data:attachment/csv;charset=utf-8,' + encodeURI(data);
      link.click();
    }).catch((error) => {
      createErrorAlert({
        message: getIntlText(props.intl, 'SETTINGS-CONTACTS-CSV-DOWNLOAD-ERROR-TITLE', 'CSV Download Error'),
        details: [getIntlText(props.intl, 'SETTINGS-CONTACTS-CSV-DOWNLOAD-ERROR-BODY', error.message)],
        autoCloseTimeout: 10,
      });
    });
  };

  const importContacts = (source, csvFile) => {
    // console.log("importContacts", source);
    if (source === "Google") {
      // console.log('processing google import');

      AppService.getInstance().importContacts('google');
    } else if (source === "Outlook") {
      // console.log('processing outlook import');

      AppService.getInstance().importContacts('outlook');

    } else if (source === "CSV") {
      // console.log('processing csv import', params, csvFile);

      // if the csvFile passed in is 'bad', post an alert
      if (!csvFile || !csvFile.name || csvFile.name.indexOf('.csv') < 0) {
        AlertService.getInstance().createErrorAlert({
          message: Utilities.getInstance().getIntlMessage('SETTINGS-CONTACTS-CSV-IMPORT-ERROR-TITLE', 'CSV Import Error'),
          details: [Utilities.getInstance().getIntlMessage('SETTINGS-CONTACTS-CSV-IMPORT-ERROR', 'file name must be .csv; your file name was: ') + csvFile.name],
          autoCloseTimeout: 5,
        });
        return;
      }
      var myForm = new FormData();
      myForm.append('file', csvFile);

      AppService.getInstance().uploadContacts({ "formData": myForm }).then((data) => {
        // console.log('Data from csv upload', data);

        // get list of contacts, set force to true so new imports are retrieved
        //actions.contacts.getUserContacts({ 'force': true });
      }).catch((error) => {
        // show alert with error status
        // calling AlertService
        AlertService.getInstance().createErrorAlert({
          message: Utilities.getInstance().getIntlMessage('SETTINGS-CONTACTS-CSV-IMPORT-ERROR-TITLE', 'CSV Import Error'),
          details: [`status: ${error.message.status} \n message: ${error.message.message}`],
          autoCloseTimeout: 5,
        });
      });
    }
  };

  return (
    <SettingsContainer className="SettingsContainer">
      <input ref={fileInput} type="file" id='csv-file' style={{ display: 'none' }} onClick={(event) => {
        event.target.value = null;
      }}
        onChange={(e) => {
          //console.log('file changing do somthing here ', e.nativeEvent.target.files[0] );
          handleContactAction('importContacts', 'CSV', e.nativeEvent.target.files[0]);
        }} />
      <SettingsItemContainer>
        <SettingsTitle className="SettingsTitleStyles">
          {getIntlText(props.intl, 'SETTINGS-IMPORT-CONTACTS', "Import Your Contacts")}
        </SettingsTitle>
        <SettingsDescription
          className="SettingsDescriptionStyles"
        >
          {getIntlText(props.intl, 'SETTINGS-IMPORT-CONTACTS-DESCRIPTION', "Select your option below to import contacts.")}
        </SettingsDescription>
        <ImportContacts importSourceArray={importSourceArray} />
        <SettingsTitle className="SettingsTitleStyles">
          {getIntlText(props.intl, 'SETTINGS-SAMPLE-CSV', "Sample CSV")}
        </SettingsTitle>
        <SettingsDescription className="SettingsDescriptionStyles">
          {getIntlText(props.intl, 'SETTINGS-SAMPLE-CSV-DESCRIPTION', "Pressing the button below will download a sample CSV file.")}
        </SettingsDescription>
        {/* we need this for the auto sizing of the button */}
        <div>
          <DownloadSampleButton
            ariaLabel={getIntlText(props.intl, 'SETTINGS-DOWNLOAD-SAMPLE-BUTTON', "Download Sample")}
            buttonLabel={getIntlText(props.intl, 'SETTINGS-DOWNLOAD-SAMPLE-BUTTON', "Download Sample")}
            cbClick={() => handleContactAction('download', 'sampleCSV')}
            className='importSourceButton'
            buttonType="secondary"
          />
        </div>
      </SettingsItemContainer>
      <SettingsTitle className="SettingsTitleStyles">
        {getIntlText(props.intl, 'SETTINGS-BACKUP', "Backup")}
      </SettingsTitle>
      <SettingsDescription className="SettingsDescriptionStyles">
        {getIntlText(props.intl, 'SETTINGS-BACKUP-DESCRIPTION', "Pressing the button below will download a CSV backup of your contacts. This is recommended before imports.")}
      </SettingsDescription>
      {/* we need this for the auto sizing of the button */}
      <div>
        <DownloadBackupButton
          ariaLabel={getIntlText(props.intl, 'SETTINGS-DOWNLOAD-BACKUP-BUTTON', "Download Backup")}
          buttonLabel={getIntlText(props.intl, 'SETTINGS-DOWNLOAD-BACKUP-BUTTON', "Download Backup")}
          cbClick={() => handleContactAction('download', 'backupCSV')}
          className='importSourceButton'
          buttonType="secondary"
        />
      </div>
    </SettingsContainer >
  );
};

ContactSettings.propTypes = {
  importSourceArray: PropTypes.array,
  cbImportActionClick: PropTypes.func
};

ContactSettings.defaultProps = {
  importSourceArray: [],
  cbImportActionClick: () => { console.log("cbImportActionClick not defined in contact settings"); }
};

export default ContactSettings;
